import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { filter, map, withLatestFrom } from 'rxjs/operators'
import { AAAStore } from '../../store/root-reducer'
import { selectActiveCallStatus } from '../dashboard/calls-statuses/call-status.selectors'
import { SET_TOW_DESTINATION } from '../location/tow-location/tow-location.actions'
import { StepTypes, TowSections } from '../ui/ui.types'

@Injectable()
export class SubmitEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<AAAStore>,
    private router: Router,
  ) {}

  handleSetTowDestination = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SET_TOW_DESTINATION.SUCCESS),
        withLatestFrom(this.store$.select(selectActiveCallStatus)),
        filter(([_, activeCallStatus]) => activeCallStatus === null),
        map(() =>
          this.router.navigate([], {
            queryParams: {
              step: StepTypes.TOWING,
              section: TowSections.PASSENGERS,
            },
          })
        )
      ),
    { dispatch: false }
  )

}
